import { IconButton, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import Theme from './Theme';

export default ({
  tooltip = '',
  iconName = 'Unknown',
  onClick = () => {},
  styles,
  className,
  id,
  buttonRef,
}) => {
  const componentStyles = mergeStyleSets({
    container: {
      lineHeight: '0',
      height: 'fit-content',
      display: 'inline-block',
      ...styles?.container,
    },
  });

  const effectiveStyles = {
    ...{
      label: {
        display: 'none',
      },
    },
    ...styles,
  };

  return (
    <span className={componentStyles.container}>
      <IconButton
        componentRef={buttonRef}
        id={id}
        iconProps={{ iconName }}
        title={tooltip}
        className={[Theme.styles.iconButton, className].join(' ')}
        styles={effectiveStyles}
        onClick={(event) => {
          const button = buttonRef?.current || event?.target?.closest('button');
          onClick();
          if (button?.blur) {
            button.blur();
          }
        }}
      />
    </span>
  );
};
